<app-calendar [dialogRef]="true"></app-calendar>
